import { CurrencyPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom, of, switchMap, take } from 'rxjs';
import { Cart, CartLine } from 'src/app/classes/utility';
import { EnvironmentService } from 'src/app/service/environment.service';
import { LocalStorageService } from 'src/app/service/localstorage.service';
import { MercuryService } from 'src/app/service/mercury.service';
import { ShopifyService } from 'src/app/service/shopify.service';
import { ThemeService } from 'src/app/service/theme.service';
import { LineitemComponent } from './lineitem/lineitem.component';
import { MotivatorComponent } from './motivator/motivator.component';
import { UpsellItemComponent } from './upsell-item/upsell-item.component';

@Component({
  selector: 'app-minicart',
  imports: [
    LineitemComponent,
    UpsellItemComponent,
    NgFor,
    NgIf,
    NgClass,
    CurrencyPipe,
    MotivatorComponent,
  ],
  templateUrl: './minicart.component.html',
  styleUrl: './minicart.component.scss',
})
export class MinicartComponent implements OnInit {
  checkout?: Cart | { state: 'loading' } | any;
  _config: any;
  _upsells: any;
  _showUpsells: boolean = true;
  @Input() theme!: any;
  constructor(
    private localStorage: LocalStorageService,
    private shopifyService: ShopifyService,
    private renderer: Renderer2,
    private mercuryService: MercuryService,
    private el: ElementRef,
    private route: ActivatedRoute,
    private themeService: ThemeService,
    private environmentService: EnvironmentService
  ) {}

  checkForGiftBag(cartLines: any[]) {
    this._showUpsells = true;
    for (let line of cartLines) {
      if (line?.node?.merchandise?.product?.productType == 'Gift Bag') {
        this._showUpsells = false;
        return;
      }
    }
  }

  async ngOnInit() {
    if (!this.environmentService.isBrowser()) return;

    this._config = await this.shopifyService.getMetaobject();

    try {
      // if (this.localStorage.getItem('vip')) {
      if (this._config?.gwp?.enabled) {
        for (const offer of this._config.gwp.offers) {
          offer.minimumTreshold = offer.minimumTreshold
            ? offer.minimumTreshold / 100
            : undefined;
          offer.maximumThreshold = offer.maximumThreshold
            ? offer.maximumThreshold / 100
            : undefined;
        }
      }
      // }
    } catch (err) {
      console.log(err);
    }

    this.shopifyService.cartObservable.subscribe(async (data) => {
      this.checkout = { ...structuredClone(data) };

      if (this.checkout?.lines) {
        this.checkForGiftBag(this.checkout?.lines?.edges);
        this.matchPersonalisation(this.checkout?.lines?.edges);
        const unmatch = this.findUnmatchedEntries(
          structuredClone(this.checkout.lines.edges.map((x: any) => x.node))
        );
        if (unmatch.length > 0) {
          await this.shopifyService
            .removeFromCart(unmatch)
            .subscribe((data) => {});
        }

        if (this.checkout?.lines?.edges) {
          this.checkout.lines.edges = this.checkout.lines.edges.filter(
            (x: any) => x.node.merchandise.product.handle != 'personalisation'
          );
        }

        try {
          // if (this.localStorage.getItem('vip')) {
          // this.bygx();
          // }
        } catch (err) {
          console.log(err);
        }

        if (this._config?.gwp?.enabled) {
          for (const offer of this._config.gwp.offers) {
            if (this.isThisASuitableFreeGift(offer)) {
              await this.addGiftToCart(offer);
              return;
            }
          }
        }
      }

      if (this.checkout?.id) {
        this.themeService.viewCart(this.checkout);
      }
    });
    this.themeService.themeEvents.subscribe((data) => {
      if (data.type == 'clear' || data.type == 'menuClose') {
        this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
        this.renderer.removeClass(this.el.nativeElement, 'active');
      } else if (data.type == 'minicartOpen') {
        this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
        this.renderer.addClass(this.el.nativeElement, 'active');
        this.shopifyService
          .getCart()
          .pipe(
            take(1),
            switchMap((data) => {
              if (!(data as Cart).id) {
                return this.shopifyService.updateCart();
              }
              return of(data); // Return the data if it has an ID
            })
          )
          .subscribe();
      }
    });
    this.route.queryParams.subscribe((params) => {
      if (params.modal == 'cart') {
        this.themeService.minicartOpen();
      }
      if (params.vip) {
        try {
          localStorage.setItem('vip', 'true');
        } catch (err) {
          console.log(err);
        }
      }
    });
    this.shopifyService.updateCart();
    this.mercuryService
      .getProductsByHandles(['gift-bag-green-stripe', 'gift-bag-oat-stripe'])
      .subscribe((data) => {
        this._upsells = structuredClone(data);
      });
  }

  isBelowMaximumThreshold(giftMode: any) {
    if (!this.checkout) return true;
    return giftMode.maximumThreshold != null
      ? giftMode.maximumThreshold >
          parseFloat((this.checkout as Cart).cost.totalAmount.amount)
      : true;
  }

  async bygx() {
    const bxgy = await lastValueFrom(
      this.mercuryService.getProductByHandle('pool-buoy-luxe-ring', true)
    ).catch((err) => null);
    if (bxgy?.variants[0].inventory_quantity == 0) {
      return;
    }
    if (this.isbygxPresentInCart() && bxgy) {
      // check if eligible and remove if not
      if (this.isbxgyConditionMet()) {
        console.log('eligible and present');
      } else {
        console.log('not eligible and present');
        await lastValueFrom(
          this.shopifyService.removeFromCart([this.isbygxPresentInCart().id])
        );
      }
    } else if (!this.isbygxPresentInCart() && bxgy) {
      // check if eligible and add
      if (this.isbxgyConditionMet()) {
        console.log('eligible and not present');
        await lastValueFrom(
          this.shopifyService.addToCart([
            {
              variantId: bxgy.variants[0].admin_graphql_api_id,
              quantity: 1,
              attributes: [{ key: '_bxgy', value: 'true' }],
            },
          ])
        );
      } else {
        console.log('not eligible and not present');
      }
    }
  }

  isbxgyConditionMet() {
    let totalCups = 0;
    for (let line of (this.checkout as Cart).lines.edges.map((x) => x.node)) {
      if (
        line.merchandise.product.productType.toLocaleLowerCase() ==
        'drink bottle'
      ) {
        totalCups = totalCups + line.quantity;
      }
    }
    if (this.isbygxPresentInCart()?.quantity > 1) {
      return false;
    }
    return totalCups >= 1;
  }

  isbygxPresentInCart() {
    return (this.checkout as Cart).lines.edges
      .map((x: any) => x.node)
      .find(
        (y: CartLine) =>
          y.merchandise.product.handle == 'pool-buoy-luxe-ring' ||
          y.attributes.find((x) => x.key == '_bxgy')
      );
  }

  isAboveMinimumThreshold(giftMode: any) {
    return (
      giftMode.minimumTreshold <
      parseFloat((this.checkout as Cart).cost.totalAmount.amount)
    );
  }

  isGiftPresentInCart(giftMode: any) {
    if (!(this.checkout as Cart).lines.edges) return;
    return (this.checkout as Cart).lines.edges
      .map((x: any) => x.node)
      .find(
        (y: CartLine) =>
          y.merchandise.product.handle == giftMode.handle &&
          y.attributes.find((x) => x.key == '_freegift')
      );
  }

  allGiftsPresentInCart() {
    return (this.checkout as Cart).lines.edges
      .map((x: any) => x.node)
      .filter((y: CartLine) => y.attributes.find((x) => x.key == '_freegift'));
  }

  allIneligibleGiftsInCart(_config: any) {
    return (this.checkout as Cart).lines.edges.filter((cartLine: any) => {
      const freeGiftAttribute = cartLine.node.attributes.find(
        (attr: any) => attr.key == '_freegift'
      );

      if (!freeGiftAttribute) return false; // Not a free gift

      const giftMode = this.getGiftModeByHandle(
        cartLine.node.merchandise.product.handle,
        this._config
      );
      if (!giftMode) return true; // If no matching giftMode, it's ineligible

      return !this.isThisASuitableFreeGift(giftMode); // Check suitability
    });
  }

  getGiftModeByHandle(handle: string, _config: any) {
    return this._config.gwp.offers.find(
      (giftMode: any) => giftMode.handle === handle
    );
  }

  isThisASuitableFreeGift(giftMode: any) {
    if (this.isGiftPresentInCart(giftMode)) return false;

    return (
      this.isBelowMaximumThreshold(giftMode) &&
      this.isAboveMinimumThreshold(giftMode)
    );
  }

  isSuitableGiftToAddToCart(data: any) {
    if (
      data.variants[0].inventory_policy === 'DENY' &&
      data.variants[0].inventory_quantity < 1
    ) {
      console.error('GIFT NO STOCK: ' + data.title + ' ' + data.handle);
      return false;
    }
    if (data.variants.length > 1 || parseFloat(data.variants[0].price) !== 0) {
      console.error('GIFT NOT SUITABLE: ' + data.title + ' ' + data.handle);
      return false;
    }
    return true;
  }

  async addGiftToCart(offer: any) {
    await lastValueFrom(
      this.mercuryService.getProductByHandle(offer.handle)
    ).then(async (data) => {
      await lastValueFrom(
        this.shopifyService.addToCart([
          {
            variantId: data.variants[0].admin_graphql_api_id,
            quantity: 1,
            attributes: [{ key: '_freegift', value: 'true' }],
          },
        ])
      );
    });
  }

  clickedOutside($event: any) {
    this.themeService.clear();
  }

  clickedInside($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  close() {
    this.themeService.clear();
  }

  matchPersonalisation(cart: any[]) {
    const updatedCart: any[] = [];

    cart.forEach((item) => {
      // Check if this is a personalization item based on the title
      const isPersonalisation =
        item.node.merchandise.product.title === 'Personalisation';

      // If it's a personalization item, find the matching cup item
      if (isPersonalisation) {
        const personalisationKey = item.node.attributes.find(
          (attr: any) => attr.key === '_Personalisation'
        )?.value;

        if (personalisationKey) {
          // Find the matching cup item
          const matchingCup = cart.find(
            (otherItem) =>
              otherItem !== item &&
              otherItem.node.attributes.some(
                (attr: any) =>
                  attr.key === '_Personalisation' &&
                  attr.value === personalisationKey
              )
          );

          // Add personalization price to the cup's total price
          if (matchingCup) {
            const cupTotal = parseFloat(
              matchingCup.node.cost.totalAmount.amount
            );
            const personalisationPrice = parseFloat(
              item.node.cost.totalAmount.amount
            );
            const cupSubTotal = parseFloat(
              matchingCup.node.cost.subtotalAmount.amount
            );
            const personalisationSubPrice = parseFloat(
              item.node.cost.subtotalAmount.amount
            );

            // Calculate the new total price
            const newSubTotal = (cupSubTotal + personalisationSubPrice).toFixed(
              2
            );
            const newTotal = (cupTotal + personalisationPrice).toFixed(2);

            // Update the cup's total price
            matchingCup.node.cost.subtotalAmount.amount = newSubTotal;

            matchingCup.node.cost.totalAmount.amount = newTotal;
          }
        }
      } else {
        // If it's not a personalization item, keep it in the updated cart
        updatedCart.push(item);
      }
    });

    return updatedCart;
  }

  findUnmatchedEntries(cartLines: CartLine[]): string[] {
    // Create a map to track personalisation keys
    const personalisationMap: { [key: string]: string[] } = {};
    const unmatchedIds: string[] = [];

    // Populate the map with personalisation keys and their corresponding IDs
    cartLines.forEach((line) => {
      const personalisationAttr = line.attributes.find(
        (attr: any) => attr.key === '_Personalisation'
      );
      if (personalisationAttr) {
        const personalisationKey = personalisationAttr.value;
        if (!personalisationMap[personalisationKey]) {
          personalisationMap[personalisationKey] = [];
        }
        personalisationMap[personalisationKey].push(line.id);
      }
    });

    // Check for lines that have the "Personalised" attribute
    cartLines.forEach((line) => {
      const personalisedAttr = line.attributes.find(
        (attr: any) => attr.key === 'Monogram'
      );
      const personalisationAttr = line.attributes.find(
        (attr: any) => attr.key === '_Personalisation'
      );
      if (personalisedAttr && personalisationAttr) {
        const personalisationKey = personalisationAttr.value;
        if (personalisationMap[personalisationKey].length < 2) {
          unmatchedIds.push(line.id);
        }
      }
    });

    // Find entries that have "_Personalisation" key but no matching "Personalised" counterpart
    for (const key in personalisationMap) {
      if (personalisationMap[key].length < 2) {
        unmatchedIds.push(...personalisationMap[key]);
      }
    }

    // Remove duplicates from unmatchedIds
    const uniqueUnmatchedIds = Array.from(new Set(unmatchedIds));

    return uniqueUnmatchedIds;
  }
}
